import * as React from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import cx from 'classnames'

import { DOC_INSIGHTS_PATH } from 'paths'
import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/readReceipt.svg'
import { Actor } from './Actor'
import Styles from 'components/ActivityEvent/ActivityEvent.module.scss'
import { ActivityEventPosition, ArticleEndReadReceiptEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: ArticleEndReadReceiptEvent
}

const ArticleEndReadReceipt = ({ event, ...props }: Props) => {
  const {
    user,
    data: {
      feedback_request: { ended_on_due_date, request_closer_name, completed_task_count, task_count },
    },
    article: { slug },
  } = event

  const history = useHistory()

  const openInsights = (e: React.MouseEvent) => {
    e.stopPropagation()
    history.push(generatePath(DOC_INSIGHTS_PATH, { slug }))
  }

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={
        <>
          {!!ended_on_due_date ? (
            <span>Read Receipt has expired. </span>
          ) : (
            <span>
              <Actor displayName={request_closer_name || user.display_name || 'Anonymous User'} userId={user?.id} />{' '}
              ended read receipt.{' '}
            </span>
          )}
          <span className={cx({ [Styles.name]: !!ended_on_due_date })}>
            {completed_task_count} out of {task_count}
          </span>{' '}
          people marked as read:{' '}
          <div className={Styles.link} onClick={openInsights}>
            Open Insights
          </div>
        </>
      }
    />
  )
}

export { ArticleEndReadReceipt }
